const PACKAGE_ALL_INCLUSIVE = 'PAI';
const PACKAGE_ROOM_ONLY = 'RON';
const PACKAGE_FOOD_AND_BEVERAGE = 'FFB';
const CEFALU_RESORT = 'CFAC';
const DELUXE_COMFORT = 'Deluxe';
const PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
const COMFORT_TYPE_SUITE = 'typeoflodging_comfort_type_suite';
const COMFORT_TYPE_CHALET = 'typeoflodging_comfort_type_chalet';
const COMFORT_TYPE_VILLA = 'typeoflodging_comfort_type_villa';

export {
  PACKAGE_ALL_INCLUSIVE,
  PACKAGE_ROOM_ONLY,
  CEFALU_RESORT,
  DELUXE_COMFORT,
  PACKAGE_FOOD_AND_BEVERAGE,
  PRICE_COUNTER_PROPOSAL_THRESHOLD,
  COMFORT_TYPE_SUITE,
  COMFORT_TYPE_CHALET,
  COMFORT_TYPE_VILLA,
};
